<div class="center-content">
	<workflow-visual-notification #notification class="hugeButton"></workflow-visual-notification>
</div>
<div *ngIf="!testRunning">
	<div class="center-content center-absolute">
		<div class="big-text centered">{{ 'workflow.optischeReaktion.ready' | translate }}</div>
	</div>
</div>
<div class="extrabuttons buttonrow replaceButtonrow">
	<div class="left-buttons"></div>
	<div class="right-buttons">
		<!--Vorwärts für Seiten einzelner Fragen-->
		<button nz-button nzType="primary" class="big-button right-one" (touchstart)="dispatchVitaReact($event)" (mousedown)="dispatchVitaReact($event)">
			{{ buttonText | translate }}
		</button>
	</div>
</div>
